<div class="simple-error-dialog-wrapper">
  <h2 class="error-header" mat-dialog-title>
<!--    <mat-icon>priority_high</mat-icon>-->
    {{ 'error.simpleErrorDialog.title' | translate }}
  </h2>
  <mat-divider></mat-divider>
  <div mat-dialog-content class="mat-typography">

    <mat-list role="list" *ngIf="data.message; else defaultMessage">
      <mat-list-item role="listitem" *ngFor="let msg of data.message">
        <mat-icon>error_outline</mat-icon> {{ msg }}
      </mat-list-item>
    </mat-list>

    <ng-template #defaultMessage>
      <mat-list role="list">
        <mat-list-item role="listitem">
          <mat-icon>error</mat-icon>
          {{ 'error.simpleErrorDialog.defaultMessage' | translate }}
        </mat-list-item>
      </mat-list>
    </ng-template>

  </div>
  <div mat-dialog-actions align="end">
    <button mat-button (click)="closeDialog()">{{ 'error.simpleErrorDialog.close' | translate }}</button>
  </div>
</div>
